<template>
  <div class="container-fluid py-4">
    <div class="row justify-content-center">
      <div class="col-12 col-md-12 col-lg-8">
        <CustomAlert v-if="$c('reportInstructions')" class="mb-4">
          {{ $c("reportInstructions") }}
        </CustomAlert>

        <CustomAlert v-if="onid" type="warning" icon="" class="mb-4 fw-bold">
          Report for {{ onid }}
        </CustomAlert>

        <div class="row">
          <div class="col-sm-4">
            <div class="sticky-top">
              <TableOfContents :isLocked="false" :hideComplete="true" />
            </div>
          </div>
          <div class="col-sm-8">
            <div
              v-for="step in filteredSteps"
              :key="step.id"
              :id="step.id"
              class="mb-4"
            >
              <PromptContainer :step="step" :isReport="true" />
            </div>
          </div>
        </div>
        <pre class="text-start" v-if="0">
          {{ getSteps }}
        </pre>
      </div>
    </div>
  </div>
</template>

<script>
import DatastoreAPI from "@/helpers/DatastoreAPI.js";
import { mapGetters } from "vuex";
import TableOfContents from "@/components/activity/TableOfContents.vue";
import PromptContainer from "@/components/activity/PromptContainer.vue";

export default {
  name: "ReportView",
  mixins: [DatastoreAPI],
  components: {
    TableOfContents,
    PromptContainer
  },
  props: {
    onid: {
      type: String,
      default: null,
      required: false
    }
  },
  computed: {
    ...mapGetters(["getSteps", "getCurrentStepId"]),
    ...mapGetters("datastore", ["getAdminEntries"]),
    filteredSteps() {
      let filtered = this.getSteps().filter((step) => step.type !== "complete");

      if (!this.onid) {
        // If onid prop is not provided, filter out type complete
        return filtered;
      }

      // If onid prop is provided, find entry for that onid
      let entry = this.getAdminEntries.find(
        (entry) => entry.onid === this.onid
      );

      if (!entry) {
        // If no entry found for onid, return filtered steps
        return filtered;
      }

      return this.getSteps(entry.value.stepValues).filter(
        (step) => step.type !== "complete"
      );
    }
  },
  created() {
    // If onid prop is provided, set current step to that onid
    this.readEntries();
  }
};
</script>

<style scoped>
.sticky-top {
  top: 20px;
}
</style>
